import React, { useState } from 'react';
import '../CSS/Common.css';
import LazyLoad from 'react-lazy-load';
import '../CSS/Responsive.css';

const SkewImg = ({ image }) => {
  const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);
  
	const handleLoad = () => {
	  setIsLoading(false); // Image has loaded successfully
	};
  
	const handleError = () => {
	  setIsLoading(false); // Image failed to load
	  setHasError(true);
	};

  return (
    <React.Fragment>
      <LazyLoad>
        <div className='skewContainer'>
          <div className='skew'></div>

              {isLoading && !hasError && (
                <div className="loading-fallback">Loading...</div>
              )}
              {hasError && (
                <div className="error-fallback">Image failed to load.</div>
              )}
              {
              <img
                src={image}
                alt="skewImage"
                className="skewImg"
                onLoad={handleLoad} // Triggered when the image loads
                onError={handleError} // Triggered if the image fails to load
                style={{ display: isLoading || hasError ? 'none' : '' }} // Hide image while loading or on error
              />
              }

          <div className='skew1'></div>
        </div>
      </LazyLoad>
    </React.Fragment>
  );
};

export default SkewImg;

// import React from 'react'
// import '../CSS/Common.css'
// import LazyLoad from 'react-lazy-load';
// import '../CSS/Responsive.css'

// const SkewImg = ({image}) => {
//   return (
//     <React.Fragment>
//       <LazyLoad>
//         <div className='skewContainer '>
//             <div className='skew'></div>
//               {
//                 !image ? 
//                   (<img className='skewImg' />)
//                    : 
//                   (<img src={image} className='skewImg'/>)
//               }
//             <div className='skew1'></div>
//         </div>
//       </LazyLoad>
//     </React.Fragment>
//   )
// }

// export default SkewImg